import type { ProductBadge } from "@/api";

/**
 * Бейджи товара человеческими словами (fd-catalog-20): «Хит», «Новинка»,
 * «Распродажа», «Эко». Раньше витрина рисовала коды шлюза (new, eco) чипами
 * во вкладке «Описание», а на плитках каталога бейджей не было вовсе.
 *
 * Порядок - по силе сигнала для покупателя: распродажа и хит важнее
 * «новинки», которую шлюз ставит сам первые 90 дней. «Кастомизация» на
 * плитке не нужна: у такого товара своя строка «Доступна кастомизация».
 */
export const BADGE_ORDER: readonly ProductBadge[] = ["sale", "bestseller", "new", "eco", "handmade", "limited"];

/** Бейджи для показа: известные, по порядку, без дублей; `limit` - сколько влезает на плитку. */
export const visibleBadges = (badges: readonly string[] | undefined, limit = BADGE_ORDER.length): ProductBadge[] => {
	const own = new Set(badges ?? []);
	return BADGE_ORDER.filter((badge) => own.has(badge)).slice(0, limit);
};
